import React from 'react';
import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import {
  RichTextRenderer,
  RichTextRendererProps,
  STYLE_RESET_CLASSNAME
} from '@kyruus/rich-text/Renderer';

export const ClinicalInterestsTitle = styled.h2`
  border: none;
  margin: 0 0 ${fromTheme('spacing_medium')};
  font-weight: ${fromTheme('font_weight_bolder')};
  font-size: ${fromTheme('font_size_heading_4')};
  color: ${fromTheme('color_text')};
`;

export const ClinicalInterestsContentText = styled(
  (props: RichTextRendererProps) => (
    <RichTextRenderer
      {...props}
      styleReset="revert" /* reset any styling from the consuming context */
    />
  )
)`
  &.${STYLE_RESET_CLASSNAME} {
    p&,
    p,
    h3,
    h4,
    h5,
    h6 {
      margin: ${fromTheme('spacing_small')} 0;
      line-height: ${fromTheme('spacing_large')};
      font-size: ${fromTheme('font_size')};
      color: ${fromTheme('color_text')};
      white-space: normal;
    }

    ul,
    ol {
      line-height: ${fromTheme('spacing_large')};
      list-style-position: outside;
      padding: 0;
      margin: 0 0 10px 25px;
      font-size: ${fromTheme('font_size')};
      font-weight: ${fromTheme('font_weight')};
      color: ${fromTheme('color_text')};
      white-space: normal;
    }

    hr {
      margin: 20px 0;
      white-space: normal;
    }

    h6 {
      font-size: 0.75em;
    }
  }
`;
